import React from 'react'
import { SupplierDetailFormAdminStyle } from './styled'
import {
  Button,
  Image,
  Input,
  Section,
  Spinner,
  Checkbox,
} from '../../components'
import { ICONS } from '../../themes'
import { ROUTE_PATH, STRING, trimmedString } from '../../helpers'
import { Form, Formik } from 'formik'
import { supplierManagementController } from '../../apiService'

import * as Yup from 'yup'
import { toast } from 'react-toastify'
export class SupplierDetailFormAdminContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      detailFrom: {
        taxId: '',
        companyName: '',
        fullName: '',
        email: '',
        phone: '',
        branch: '',
        supplierNation: 'thailand',
        disableButton: true,
      },
      verify: false,
      companyData: {},
      isLoading: false,
      isVerifyLoading: false,
      supplierNation: 'thailand',
    }
  }

  _onChangeNation(e, formikActions) {
    formikActions.setFieldValue('supplierNation', e.target.value)
    if (e.target.value === 'overseas') {
      formikActions.setFieldValue('disableButton', false)
    } else {
      formikActions.setFieldValue('disableButton', true)
    }
    formikActions.setErrors({})
  }

  onClickVerify = async formikActions => {
    if (!formikActions.values.taxId) {
      return formikActions.setErrors({ taxId: STRING.INVALID })
    }
    try {
      this.setState({ isVerifyLoading: true })
      const res = await supplierManagementController().verifyTaxID(
        formikActions.values.taxId
      )
      const company =
        res && Array.isArray(res.data) ? res.data[0] : res && res[0]
      const companyName = company && (company.JP_TNAME || company.JP_ENAME)
      if (companyName) {
        this.setState(prev => ({
          verify: true,
          isVerifyLoading: false,
          detailFrom: {
            ...prev.detailFrom,
            ...formikActions.values,
            companyName,
            disableButton: false,
          },
        }))
      } else {
        this.setState({ verify: true, isVerifyLoading: false })
        formikActions.setErrors({ taxId: STRING.TAX_CHECK })
        formikActions.setFieldValue('disableButton', true)
      }
    } catch (error) {
      this.setState({ isVerifyLoading: false })
      formikActions.setErrors({ taxId: STRING.TAX_CHECK })
      formikActions.setFieldValue('disableButton', true)
    }
  }

  onClickCancel = () => {
    this.props.history.push(ROUTE_PATH.SUPPLIER_MANAGEMENT_ADMIN.LINK)
  }

  createSupplier = async (values, formikActions) => {
    console.log('create')
    if (
      values &&
      values.companyName &&
      values.fullName &&
      values.email &&
      values.phone
    ) {
      const params = {
        tax_id: values.taxId,
        company_name: trimmedString(values.companyName),
        // regis_address: '',
        // regis_country: '',
        // contact_address: '',
        // contact_country: '',
        // phone: '',
        // fax: '',
        // email: '',
        // website: '',
        // supplier_portal: '',
        admin_supplier_full_name: trimmedString(values.fullName),
        admin_supplier_email: trimmedString(values.email),
        admin_supplier_phone: trimmedString(values.phone),
        branch: trimmedString(values.branch),
      }
      const res = await supplierManagementController().createSupplier(params)
      if (res) {
        this.setState({ isLoading: false })
        if (res.status === 'SendMailSuccess') {
          toast.success('Create was success')
          this.goListSuppilerManagementPage()
          setTimeout(formikActions.resetForm(), 3000)
        } else if (res.status === 'EmailDuplicate') {
          toast.error(res.message)
        }
      }
    }
  }

  onSubmit = async (values = {}, formikActions = () => {}) => {
    try {
      this.setState({ isLoading: true })
      if (values && formikActions) {
        this.createSupplier(values, formikActions)
      }
    } catch (error) {
      throw error
    }
  }

  handleInput = (formikActions = () => {}, e) => {
    const { name, value } = e.target

    console.log(name, value)
    formikActions.setFieldValue(name, value)
    formikActions.setErrors({ ...formikActions.errors, [name]: '' })
  }

  handleInputTaxId = (formikActions = () => {}, e) => {
    const { name, value } = e.target
    if (value !== formikActions.values.taxId) {
      formikActions.setFieldValue(name, value)
      formikActions.setErrors({ ...formikActions.errors, taxId: '' })
      this.setState({ disableButton: true, verify: false })
    }
  }

  goListSuppilerManagementPage = () => {
    this.props.history.push(ROUTE_PATH.SUPPLIER_MANAGEMENT_ADMIN.LINK)
  }

  validateStrEmpty = values => {
    let errors = {}
    const email = trimmedString(values.email)
    const taxId = trimmedString(values.taxId)
    const phone = trimmedString(values.phone)
    const fullName = trimmedString(values.fullName)
    if (email.length === 0) {
      errors.email = STRING.INVALID
    }
    if (phone.length === 0) {
      errors.phone = STRING.INVALID
    }
    if (taxId.length === 0) {
      errors.taxId = STRING.INVALID
    }
    if (fullName.length === 0) {
      errors.fullName = STRING.INVALID
    }
    return errors
  }

  validateSchema = () => {
    const schema = Yup.object().shape({
      taxId: Yup.string().required(STRING.INVALID),
      companyName: Yup.string().required(STRING.INVALID),
      fullName: Yup.string()
        .transform(fullName => trimmedString(fullName))
        .required(STRING.INVALID),
      email: Yup.string()
        .transform(email => trimmedString(email))
        .required(STRING.INVALID)
        .email(STRING.EMAIL_INVALID),
      phone: Yup.string()
        .transform(phoneValue => trimmedString(phoneValue))
        .required(STRING.INVALID),
      branch: Yup.string().when('supplierNation', {
        is: supplierNation => supplierNation === 'thailand',
        then: Yup.string().required(STRING.INVALID),
      }),
    })
    return schema
  }

  render() {
    const { isVerifyLoading, supplierNation } = this.state
    return (
      <React.Fragment>
        <SupplierDetailFormAdminStyle>
          {/* PAGE TITLE
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="page-topbar">
            <Section className="page-header">
              <Section className="page-icon">
                <Image
                  id="page_icon_supplier_form"
                  src={ICONS['icon-user-white.svg']}
                  alt="page icon"
                />
              </Section>

              <Section className="title-and-breadcrumb">
                <Section id="page_title_supplier_form" className="title">
                  Supplier Management
                </Section>

                <Section
                  id="page_breadcrumb_supplier_form"
                  className="breadcrumbs"
                >
                  <Button
                    className="breadcrumb"
                    onClick={() => {
                      this.props.history.push(ROUTE_PATH.HOME.LINK)
                    }}
                  >
                    <span>{STRING.HOME}</span>
                  </Button>

                  <Button
                    onClick={() => {
                      this.props.history.push(
                        ROUTE_PATH.SUPPLIER_MANAGEMENT_ADMIN.LINK
                      )
                    }}
                    className="breadcrumb"
                  >
                    <span>Supplier Management</span>
                  </Button>

                  <Button className="breadcrumb current">
                    <span>Create Supplier</span>
                  </Button>
                </Section>
              </Section>
            </Section>
          </Section>

          {/* PAGE CONTENT
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Formik
            validationSchema={this.validateSchema}
            enableReinitialize={true}
            initialValues={this.state.detailFrom}
            validateOnBlur={true}
            validateOnChange={false}
            validateOnMount={false}
            // validate={values => this.validateStrEmpty(values)}
            onSubmit={(values, actions) => {
              this.onSubmit(values, actions)
            }}
          >
            {formikProp => {
              return (
                <Section className="main-content form">
                  <Section className="content-body">
                    {this.state.isLoading ? (
                      <Section className="loading">
                        <Spinner />
                      </Section>
                    ) : (
                      <React.Fragment>
                        <Section className="form-wrapper">
                          <Section className="form-group-title">
                            Create Supplier
                          </Section>

                          <Section className="form-group checkbox supplier-nation">
                            <label></label>

                            <Section className="form-group-control">
                              <Section className="form-group-inner-wrapper">
                                <Checkbox
                                  id="supplierNation_thailand"
                                  value="thailand"
                                  type="radio"
                                  name="supplierNation"
                                  className="inline"
                                  checked={
                                    formikProp.values.supplierNation ===
                                    'thailand'
                                  }
                                  onChange={e =>
                                    this._onChangeNation(e, formikProp)
                                  }
                                >
                                  Thailand
                                </Checkbox>

                                <Checkbox
                                  id="supplierNation_overseas"
                                  value="overseas"
                                  type="radio"
                                  name="supplierNation"
                                  className="inline"
                                  checked={
                                    formikProp.values.supplierNation ===
                                    'overseas'
                                  }
                                  onChange={e =>
                                    this._onChangeNation(e, formikProp)
                                  }
                                >
                                  Overseas
                                </Checkbox>
                              </Section>
                            </Section>
                          </Section>

                          <Section
                            className={`form-group ${
                              formikProp.errors.taxId && 'is-error'
                            }`}
                          >
                            <label>Tax ID</label>

                            <Section className="form-group-control">
                              <Section className="form-group-inner-wrapper">
                                <Input
                                  type="text"
                                  name="taxId"
                                  value={formikProp.values.taxId}
                                  onChange={event =>
                                    this.handleInputTaxId(formikProp, event)
                                  }
                                  onBlur={formikProp.handleBlur('taxId')}
                                />
                                {formikProp.values.supplierNation ===
                                  'thailand' && (
                                  <Button
                                    disabled={this.state.verify ? true : false}
                                    className="theme-blue verify"
                                    onClick={() =>
                                      this.onClickVerify(formikProp)
                                    }
                                  >
                                    {!isVerifyLoading ? (
                                      'Verify'
                                    ) : (
                                      <span className="loader" />
                                    )}
                                  </Button>
                                )}
                              </Section>

                              <Section className="message">
                                {formikProp.errors.taxId}
                              </Section>
                            </Section>
                          </Section>

                          <Section
                            className={`form-group ${
                              formikProp.errors.companyName && 'is-error'
                            }`}
                          >
                            <label>Company Name</label>

                            <Section className="form-group-control">
                              <Section className="form-group-inner-wrapper">
                                <Input
                                  type="text"
                                  name="companyName"
                                  disabled={
                                    formikProp.values.supplierNation ===
                                    'thailand'
                                  }
                                  onChange={event =>
                                    this.handleInput(formikProp, event)
                                  }
                                  onBlur={formikProp.handleBlur('companyName')}
                                  value={formikProp.values.companyName}
                                />
                              </Section>

                              <Section className="message">
                                {formikProp.errors.companyName}
                              </Section>
                            </Section>
                          </Section>

                          <Section
                            className={`form-group ${
                              formikProp.errors.branch && 'is-error'
                            }`}
                          >
                            <React.Fragment>
                              {formikProp.values.supplierNation ===
                              'thailand' ? (
                                <label forHTML="branch">Branch</label>
                              ) : (
                                <label forHTML="branch">
                                  Branch <br /> (Optional)
                                </label>
                              )}

                              <Section className="form-group-control">
                                <Section className="form-group-inner-wrapper">
                                  <Input
                                    type="text"
                                    name="branch"
                                    id="branch"
                                    required={
                                      formikProp.values.supplierNation ===
                                      'thailand'
                                    }
                                    value={formikProp.values.branch}
                                    onChange={event =>
                                      this.handleInput(formikProp, event)
                                    }
                                    onBlur={formikProp.handleBlur('branch')}
                                  />
                                </Section>

                                <Section className="message">
                                  {formikProp.errors.branch}
                                </Section>
                              </Section>
                            </React.Fragment>
                          </Section>

                          <Section className="form-group-header">
                            Contact Person
                          </Section>

                          <Section
                            className={`form-group ${
                              formikProp.errors.fullName && 'is-error'
                            }`}
                          >
                            <label>Full name</label>

                            <Section className="form-group-control">
                              <Section className="form-group-inner-wrapper">
                                <Input
                                  type="text"
                                  name="fullName"
                                  value={formikProp.values.fullName}
                                  onChange={event => {
                                    this.handleInput(formikProp, event)
                                  }}
                                  onBlur={formikProp.handleBlur('fullName')}
                                />
                              </Section>

                              <Section className="message">
                                {formikProp.errors.fullName}
                              </Section>
                            </Section>
                          </Section>

                          <Section
                            className={`form-group ${
                              formikProp.errors.email && 'is-error'
                            }`}
                          >
                            <label>Email</label>

                            <Section className="form-group-control">
                              <Section className="form-group-inner-wrapper">
                                <Input
                                  type="text"
                                  name="email"
                                  value={formikProp.values.email}
                                  onChange={event => {
                                    this.handleInput(formikProp, event)
                                  }}
                                  onBlur={formikProp.handleBlur('email')}
                                />
                              </Section>

                              <Section className="message">
                                {formikProp.errors.email}
                              </Section>
                            </Section>
                          </Section>

                          <Section
                            className={`form-group ${
                              formikProp.errors.phone && 'is-error'
                            }`}
                          >
                            <label>Phone</label>

                            <Section className="form-group-control">
                              <Section className="form-group-inner-wrapper">
                                <Input
                                  type="text"
                                  name="phone"
                                  value={formikProp.values.phone}
                                  onChange={event => {
                                    this.handleInput(formikProp, event)
                                  }}
                                  onBlur={formikProp.handleBlur('phone')}
                                />
                              </Section>

                              <Section className="message">
                                {formikProp.errors.phone}
                              </Section>
                            </Section>
                          </Section>
                        </Section>
                        <Section className="form-actions">
                          <Button
                            className="theme-border-gray"
                            onClick={() => this.onClickCancel()}
                          >
                            Cancel
                          </Button>

                          <Button
                            disabled={
                              formikProp.values.disableButton ? true : false
                            }
                            className="theme-green"
                            onClick={formikProp.handleSubmit}
                          >
                            Save
                          </Button>
                        </Section>
                      </React.Fragment>
                    )}
                  </Section>
                </Section>
              )
            }}
          </Formik>
        </SupplierDetailFormAdminStyle>
      </React.Fragment>
    )
  }
}
